import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  waitingForEvent: {},
  customEvents: {
    agentState: [],
    agentTerminal: [],
    kpiCounter: {}
  },
  queuedCallbacks: {
    interaction: {},
    element: {}
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
